import { PACKAGE_EVENTS } from 'Sp/Angular/Events/Client/Gallery';
import { PACKAGE_SMALL_SCREEN_STATES } from 'Sp/Gallery';
import { getProductDisplayMediaType } from 'ts/common/mediaType';
import { getMediaLabelKey } from 'ts/common/mediaTypeLabels';
import spPackageSingleItemTileTemplate from '../../templates/components/sp-package-single-item-tile.nghtml';

/**
 * @ngdoc component
 * @name sp.client.gallery.component:spPackageSingleItemTile
 *
 * @requires sp.client.common.service:SPPhoto
 * @requires sp.newcommon.service:spEventBus
 * @requires sp.client.gallery.service:spPackages
 *
 * @description
 * Renders a Single Pose Package Item selection tile.
 */
export default {
    controller: [
        'SPPhoto',
        'spEventBus',
        'spPackages',
        function spPackageSingleItemTileController(SPPhoto, spEventBus, spPackages) {
            const PHOTO_SIZE =
                window.getDevicePixelRatio() === 1 || window.isSmallDevice() ? 'm' : 'l';
            const $ctrl = this;

            Object.assign($ctrl, {
                deleteSelectedItemPhoto,
                getSinglePhotoFilename,
                getSinglePhotoUrl,
                isSinglePackageItemSelected: spPackages.isSinglePackageItemSelected,
                selectSingleItem,
                selectionTextKey: null
            });

            // This tile stands for the whole package rather than one item, so it asks the package,
            // which names a media type only when every product in it agrees and says "photo" for a
            // mixed one. The selected package is fixed while the tile is mounted, so deriving it
            // once keeps a walk over every package item off the digest.
            $ctrl.$onInit = () => {
                $ctrl.selectionTextKey = getMediaLabelKey(
                    'selectPhoto',
                    getProductDisplayMediaType(spPackages.getSelectedPackage())
                );
            };

            function deleteSelectedItemPhoto($event) {
                $event.stopPropagation();

                // Through the single pose path like every other assignment here, so clearing the
                // tile also clears a refusal left over from the asset being removed.
                spPackages.assignSinglePosePhoto(null);
            }

            function getSinglePhotoFilename() {
                const photo = spPackages.getAssignedSinglePhoto();

                if (photo) {
                    return photo.filename;
                }

                return false;
            }

            function getSinglePhotoUrl() {
                const photo = spPackages.getAssignedSinglePhoto();

                if (photo) {
                    return SPPhoto.getUrl(photo, PHOTO_SIZE);
                }

                return false;
            }

            function selectSingleItem() {
                const photo = spPackages.getSelectedPackagePhoto();

                if (photo && !window.isSmallDevice()) {
                    spPackages.assignSinglePosePhoto(photo);
                } else {
                    if (!$ctrl.isSinglePackageItemSelected()) {
                        spPackages.selectPackageSingleItem();
                    }

                    spPackages.setSmallScreenState(PACKAGE_SMALL_SCREEN_STATES.PHOTO_VIEW);
                    spEventBus.emit(PACKAGE_EVENTS.SELECT);
                }
            }
        }
    ],
    template: spPackageSingleItemTileTemplate
};
